import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from './utils';

type CardProps = HTMLAttributes<HTMLElement> & {
    as?: 'article' | 'section' | 'div';
    children: ReactNode;
};

function Card({ as: Comp = 'article', className, children, ...props }: CardProps) {
    return (
        <Comp className={cn('nx-card', className)} {...props}>
            {children}
        </Comp>
    );
}

type CardHeadProps = Omit<HTMLAttributes<HTMLElement>, 'title'> & {
    title?: ReactNode;
    children?: ReactNode;
    actions?: ReactNode;
};

function CardHead({ title, children, actions, className, ...props }: CardHeadProps) {
    return (
        <header className={cn('nx-card-head', className)} {...props}>
            {title != null ? <h2>{title}</h2> : children}
            {actions}
        </header>
    );
}

/** Alias semântico para painéis do Dashboard / listagens */
function PanelCard({ className, ...props }: CardProps) {
    return <Card className={cn(className)} {...props} />;
}

export { Card, CardHead, PanelCard };
export type { CardProps, CardHeadProps };
